import { createFileRoute } from '@tanstack/react-router';
import { useStore } from '@tanstack/react-store';
import { gyikData } from '~/data/faq';
import { PageSection } from '~/routes/__root';
import { langStore } from '~/store/langStore';
import { MarkdownBlock } from '~/utils/markdown';

export const Route = createFileRoute('/about/faq')({
  component: FAQ,
});

function FAQ() {
  const locale = useStore(langStore, s => s);
  const title = gyikData[locale].split('\n')[0];
  return (
    <PageSection>
      <MarkdownBlock>
        {title}
      </MarkdownBlock>
      <div className="border-2 border-orange p-5 md:p-10">
        <MarkdownBlock
          renderers={{
            a: ({ node, ...props }) => (
              <a className="text-red" rel="noreferrer" {...props} />
            ),
            ol: ({ node, ...props }) => <ol className="mt-4 list-decimal pl-5 text-lg font-semibold" {...props}></ol>,
          }}
        >
          {gyikData[locale].replace(title, '')}
        </MarkdownBlock>
      </div>
    </PageSection>
  );
}
